/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BulkDeleteExpenseItemsInput = {
    ids?: Array<string | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type bulkDeleteExpenseItemsMutationVariables = {
    input: BulkDeleteExpenseItemsInput;
};
export type bulkDeleteExpenseItemsMutationResponse = {
    readonly bulkDeleteExpenseItems: {
        readonly deletedExpenseItemIds: ReadonlyArray<string | null> | null;
    } | null;
};
export type bulkDeleteExpenseItemsMutation = {
    readonly response: bulkDeleteExpenseItemsMutationResponse;
    readonly variables: bulkDeleteExpenseItemsMutationVariables;
};



/*
mutation bulkDeleteExpenseItemsMutation(
  $input: BulkDeleteExpenseItemsInput!
) {
  bulkDeleteExpenseItems(input: $input) {
    deletedExpenseItemIds
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "BulkDeleteExpenseItemsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkDeleteExpenseItemsPayload",
    "kind": "LinkedField",
    "name": "bulkDeleteExpenseItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedExpenseItemIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkDeleteExpenseItemsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkDeleteExpenseItemsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "bulkDeleteExpenseItemsMutation",
    "operationKind": "mutation",
    "text": "mutation bulkDeleteExpenseItemsMutation(\n  $input: BulkDeleteExpenseItemsInput!\n) {\n  bulkDeleteExpenseItems(input: $input) {\n    deletedExpenseItemIds\n  }\n}\n"
  }
};
})();
(node as any).hash = '4f82b26d01f033418ea0ec985e7eba40';
export default node;
